import { axiosClient } from './axiosClient';
import type { ApiResponse } from '../types/api.types';
import type {
  AccessTokenResponse,
  AuthUserResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LogoutResponse,
  RefreshTokenRequest,
  RegisterClientRequest,
  RegisterPilotRequest,
  ResetPasswordRequest,
  TokenResponse,
} from '../types/auth.types';

export const authApi = {
  registerClient: async (payload: RegisterClientRequest) => {
    const response = await axiosClient.post<ApiResponse<TokenResponse>>('/auth/register-client', payload);
    return response.data;
  },
  registerPilot: async (payload: RegisterPilotRequest) => {
    const response = await axiosClient.post<ApiResponse<TokenResponse>>('/auth/register-pilot', payload);
    return response.data;
  },
  login: async (payload: LoginRequest) => {
    const response = await axiosClient.post<ApiResponse<TokenResponse>>('/auth/login', payload);
    return response.data;
  },
  me: async () => {
    const response = await axiosClient.get<ApiResponse<AuthUserResponse>>('/auth/me');
    return response.data;
  },
  refreshToken: async (payload: RefreshTokenRequest) => {
    const response = await axiosClient.post<ApiResponse<AccessTokenResponse>>('/auth/refresh-token', payload);
    return response.data;
  },
  logout: async () => {
    const response = await axiosClient.post<ApiResponse<LogoutResponse>>('/auth/logout');
    return response.data;
  },
  forgotPassword: async (payload: ForgotPasswordRequest) => {
    const response = await axiosClient.post<ApiResponse<ForgotPasswordResponse>>('/auth/forgot-password', payload);
    return response.data;
  },
  resetPassword: async (payload: ResetPasswordRequest) => {
    const response = await axiosClient.post<ApiResponse<{ reset: boolean }>>('/auth/reset-password', payload);
    return response.data;
  },
};
